import { Heading, Text, Box } from '@medely/ui-kit';
import React from 'react';
import { ApplicationReceivedItem } from './components/ApplicationReceivedItem';

export const ApplicationReceived = ({ isMobile = false }: { isMobile?: boolean }) => {
  return (
    <Box p={isMobile ? 2 : 4}>
      <Box py={isMobile ? 0 : 2} pb={isMobile ? 2 : 0}>
        <Heading size="m" testId="thank-you-title" textAlign={isMobile ? 'center' : 'left'}>
          Application Received!
        </Heading>
      </Box>
      <Text size="m" testId="thank-you-subtitle">
        A Medely Clinical Specialist will review your application and reach out shortly with your
        next steps.
      </Text>
      <Box py={2}>
        <Heading size="s">Why Medely</Heading>
      </Box>

      <ApplicationReceivedItem
        iconName="phone"
        text="Independently book shifts from your phone"
        isMobile={isMobile}
      />
      <ApplicationReceivedItem
        iconName="mobile"
        text="Work flexibly—there’s no minimum commitment"
        isMobile={isMobile}
      />
      <ApplicationReceivedItem
        iconName="location-dot"
        text="Book single PRN shifts and assignments in your area"
        isMobile={isMobile}
      />
      <ApplicationReceivedItem
        iconName="plane"
        text="Find travel assignments throughout the United States"
        isMobile={isMobile}
      />
      <ApplicationReceivedItem
        iconName="award"
        text="Medely is Joint Commission Certified"
        isMobile={isMobile}
      />
    </Box>
  );
};
